<template>
  <div :ref="refName"></div>
</template>
<script>
import * as echarts from 'echarts';
export default {
  name: 'ChartBlock',
  props: {
    option: {
      type: Object,
      default: () => {}
    },
    refName: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      chart: null,
    }
  },
  watch: {
    option: {
      handler(newValue, oldValue) {
        this.chart.setOption(newValue)
      },
      // 因为option是个对象，而我们对于echarts的配置项，要更改的数据往往不在一级属性里面
      // 所以这里设置了deep:true，vue文档有说明
      deep: true
    }
  },
  mounted() {
    this.chart = echarts.init(this.$refs[this.refName])
    this.chart.setOption(this.option)
    window.onresize = () => {
      return (() => {
        this.chart = echarts.init(this.$refs[this.refName])
        this.$refs[this.refName].removeAttribute('_echarts_instance_')
        this.chart.setOption(this.option)
      })()
    }
  },
  methods: {
  }
}
</script>